<template>
  <div class="kpt-detail-content-page">
    <vue-headful :title="`${remote.name} - Metrics`" />
    <div class="kpt-detail-content-actions">
      <div v-if="!isCreatingGraph">
        <b-button type="is-primary is-outlined" size="is-small" icon-left="plus" @click="isCreatingGraph = true;">Create Graph</b-button>
      </div>
      <div v-else>
        <!-- create-graph -->
        <metric-chart-create @success="graphCreated" @cancel="graphCreateCancel"></metric-chart-create>
      </div>
    </div>
    <div class="kpt-detail-metrics-graphs">
      <p class="title is-5 is-uppercase">Metric Graphs</p>
      <p v-if="graphs && graphs.length == 0">Add some graphs via the button above!</p>
      <div class="metric-graphs" v-else>
        <div class="box" v-for="graph in graphs" :key="graph.id">
          <metric-chart 
            :graph="graph" 
            :remote-id="remote.id" 
            :remote-devices="remoteDevices"
            @remove="removeGraph"></metric-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MetricChart from '../components/RemoteDetailMetricChartComponent.vue';
import MetricChartCreate from '../components/RemoteDetailMetricChartCreateComponent.vue';

export default {
  async mounted() {
    // snag the available metric providers
    await this.$store.dispatch('fetchMetricProviders', {});
  },
  components: { MetricChartCreate, MetricChart },
  computed: {
    remote() {
      return this.$store.state.remotes.remote;
    },
    remoteDevices() {
      return this.$store.state.remotes.remoteDevices;
    },
    graphs() {
      return this.$store.state.user.settings.userGraphs;
    },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    graphCreated(newGraph) {
      this.isCreatingGraph = false; 
      // KyAnalytics client plugin, event tracker
      this.$kya.event('remotes', 'metricGraphCreate', 'Create Graph clicked.', { remoteId: this.remote.id });
    },
    graphCreateCancel() {
      // KyAnalytics client plugin, event tracker
      this.$kya.event('remotes', 'metricGraphCancel', 'Cancelled Graph Create.', { remoteId: this.remote.id });
      this.isCreatingGraph = false; 
    },
    removeGraph(graphId) {
      // KyAnalytics client plugin, event tracker
      this.$kya.event('remotes', 'metricGraphRemove', 'Remove Graph clicked.', { remoteId: this.remote.id });
      this.$store.commit('removeUserGraph', graphId);
      this.$store.dispatch('updateSetting', { key: 'userGraphs', value: this.graphs });
    }
  },
  data() {
    return {
      isCreatingGraph: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/mixins';
@import "../../styles/_colors";

.kpt-detail-content-page {
  .kpt-detail-content-actions {    
    .kpt-create-graph {
      h5 {
        margin-bottom: 15px;
      }
      &::v-deep .label {
        font-weight: 400;
      }
    }
  }
  .kpt-detail-metrics-graphs {

    .metric-graphs {
      @include display-grid;
      grid-template-columns: 1fr 1fr;
      gap: 13px;
      flex-wrap: wrap;

      .box {
        padding: 12px;
        min-width: 400px;
        margin-bottom: 0px;
      }
    }
  }
}
</style>
